import { type FC } from "react";

interface AvatarProps {
  url: string | null;
  name: string;
  className?: string;
}

const Avatar: FC<AvatarProps> = ({ url, name, className = "" }) => {
  return (
    url ? (
      <img
        src={url}
        className={`size-6 rounded-full border border-lastbot-border-inverse box-content ${className}`}
      />
    ) : (
      <div
        data-testid="avatar-fallback"
        className={`flex items-center justify-center bg-lastbot-icon-muted font-semibold text-sm text-lastbot-on-inverse uppercase size-6 rounded-full border border-lastbot-border-inverse box-content ${className}`}
      >
        {name.charAt(0)}
      </div>
    )
  );
};

export default Avatar;
